import React, { forwardRef } from 'react';
import { Checkbox, ConfigProvider } from 'antd';
import './components.scss';
import Label from './Label';
import HelperText from './HelperText';
import { CheckboxChangeEvent } from 'antd/es/checkbox';

type Props = {
  disabled?: boolean;
  options?: {
    value: string | number | boolean;
    label: React.ReactNode;
    disabled?: boolean;
  }[];
  helperText?: string;
  label?: string;
  required?: boolean;
  status?: 'error' | 'success';
  onChange?: ((e: CheckboxChangeEvent) => void) | undefined;
  labelHelperText?: string;
} & React.ComponentProps<typeof Checkbox.Group>;

const ChechboxGroup = forwardRef<HTMLInputElement, Props>(
  (
    {
      disabled,
      options,
      label,
      labelHelperText,
      required,
      helperText,
      status,
      ...props
    }: Props,
    ref
  ) => {
    return (
      <div className="flex flex-col checkboxGroub">
        {label && (
          <Label
            labelHelperText={labelHelperText}
            required={required}
            text={label}
          />
        )}
        <ConfigProvider
          theme={{
            token: {
              colorBgContainer: '#F1F4FF',
              colorPrimary: '#FD9FFD',
              colorBorder: '#FD9FFD',
            },
          }}
        >
          <Checkbox.Group
            options={options}
            disabled={disabled}
            {...props}
            ref={ref}
          />
        </ConfigProvider>
        {helperText && <HelperText text={helperText} status={status} />}
      </div>
    );
  }
);
ChechboxGroup.displayName = 'ChechboxGroup';

export default ChechboxGroup;
